import React from "react";
import { Flex, Text, Box } from "rebass";
import { HR } from "./HR";

export const CardHeader: React.FC<{
    headerText?: string;
    left?: React.ReactNode;
    center?: React.ReactNode;
    right?: React.ReactNode;
}> = ({ headerText, left= <div/>, center=<div/>, right =<div/>}) => {
    return (
        <Box padding={3}>
            <Flex
                paddingBottom={3}
                justifyContent="space-between"
                alignItems="center"
            >
                <div>
                    {left}
                    <Text textAlign="center" fontWeight="bold" fontSize={[2, 4]}>
                        {headerText}
                    </Text>
                </div>
                {center}
                {right}
            </Flex>
            <HR />
        </Box>
    );
};
